export default "__VITE_ASSET__DamhYAXM__"